import * as constants from '../constants';
import { ThunkDispatch } from 'redux-thunk';
import { Venues, VendorsApi } from '@weddingspot/ws-api-client';
import { addServerError, ErrorAction } from './errors';
import { StoreState } from '../types';
import { Action } from 'redux';

export interface LoadMassInquiryVenues {
    type: constants.LOAD_MASS_INQUIRY_VENUES;
    payload: Venues.VenueRecommendation[];
}

export function loadMassInquiryVenues(venueIds: number[]) {
    return function (dispatch: ThunkDispatch<StoreState, undefined, Action>) {
        return VendorsApi.getVenuesDataForInquiry(venueIds)
            .then((res: Venues.VenueRecommendation[]) => {
                dispatch({
                    type: constants.LOAD_MASS_INQUIRY_VENUES,
                    payload: res,
                });
                return res;
            })
            .catch((err) => {
                dispatch(addServerError(err.status));
                return err;
            });
    };
}
